import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ImageModal from './ImageModal';

const ImageSection = ({ image, heading }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);

  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Container className="mt-4 mt-md-0">
        <Row>
          <Col>
            <img
              style={{
                boxShadow: '0px 4px 50px 0px #0000001A',
                cursor: 'pointer',
              }}
              className="section-image"
              src={image}
              alt={heading}
              onClick={handleShowModal}
            />
          </Col>
        </Row>
      </Container>

      <ImageModal
        show={showModal}
        handleClose={handleCloseModal}
        image={image}
        heading={heading}
      />
    </>
  );
};

export default ImageSection;
